"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TableView = function TableView() {
  return _react2.default.createElement(
    "g",
    { id: "table-view" },
    _react2.default.createElement("path", {
      d: "M0,297.7 L153.7,297.7 L153.7,203.3 L0,203.3 L0,297.7 L0,297.7 Z M173.1,297.7 L326.9,297.7 L326.9,203.3 L173.1,203.3 L173.1,297.7 L173.1,297.7 Z M346.3,203.2 L346.3,297.6 L500,297.6 L500,203.2 L346.3,203.2 L346.3,203.2 Z M0,181.4 L153.7,181.4 L153.7,87 L0,87 L0,181.4 L0,181.4 Z M173.1,181.4 L326.9,181.4 L326.9,87 L173.1,87 L173.1,181.4 L173.1,181.4 Z M346.3,87 L346.3,181.4 L500,181.4 L500,87 L346.3,87 L346.3,87 Z M0,413.9 L153.7,413.9 L153.7,319.5 L0,319.5 L0,413.9 L0,413.9 Z M173.1,413.9 L326.9,413.9 L326.9,319.5 L173.1,319.5 L173.1,413.9 L173.1,413.9 Z M346.3,413.9 L500,413.9 L500,319.5 L346.3,319.5 L346.3,413.9 L346.3,413.9 Z",
      id: "Shape"
    })
  );
};

exports.default = TableView;


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-icon/Icons/TableView.js
// module id = 2995
// module chunks = 4